// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2kedQ","buttons":"styles_buttons__2QwSb"};